import styled from '@emotion/styled'
import { Color } from '../theme'

export default styled.span`
  color: ${Color.failure};
`
